





























































import johaisetsuCompanyMasterAbilityApi from '@/apis/admin/johaisetsu_company_master_ability';
import abilityApi from '@/apis/ability';
import {
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';
import {
  AdminJohaisetsuCompanyMasterAbility,
} from '@/models/apis/johaisetsuCompanyMasterAbility/adminJohaisetsuCompanyMasterAbilityResponse';
import { AdminAbility } from '@/models/apis/ability/adminAbilityResponse';
import { AdminListTableField } from '@/types/adminListTable';
import { filterJohaisetsuDriverAbilities } from '@/lib/abilityHelper';
import { johaisetsuAreas } from '@/lib/johaisetsu/johaisetsuCommonUtil';

interface AdminJohaisetsuCompanyMasterAbilityRow extends AdminJohaisetsuCompanyMasterAbility {
  ability_names: string;
  formal_name: string;
}

const AREA_DISP_NAME_MAP = new Map<string, string>([
  ...johaisetsuAreas.map((e): [string, string] => [e.name, e.dispName]),
  ['honsha', '本社'],
  ['driver', 'ドライバー'],
]);

interface AdminJohaisetsuCompanyMasterAbilityEdit {
  id: number;
  alias_name: string;
  ability_ids: number[];
}

interface AdminJohaisetsuCompanyMasterAbilitiesState {
  companies: AdminJohaisetsuCompanyMasterAbilityRow[];
  availableAbilities: AdminAbility[];
  showEditModal: boolean;
  editting: AdminJohaisetsuCompanyMasterAbilityEdit;
  errorBody: string;
}

export default defineComponent({
  name: 'admin-johaisetsu-company-master-abilities',
  setup() {
    const state = reactive<AdminJohaisetsuCompanyMasterAbilitiesState>({
      companies: [],
      availableAbilities: [],
      showEditModal: false,
      editting: { id: 0, alias_name: '', ability_ids: [] },
      errorBody: '',
    });

    const canDeleteRow = (): boolean => false;

    const canEditRow = (row: AdminJohaisetsuCompanyMasterAbilityRow): boolean => {
      return row.is_partner_company;
    };

    const getAbilityNamesForDisp = (abilities: AdminAbility[]): string => {
      return [...abilities].sort((a, b) => a.id - b.id).map(e => e.name).join('、');
    };

    const getAreaNameForDisp = (area: string): string => {
      return AREA_DISP_NAME_MAP.get(area) ?? area;
    };

    const fields: AdminListTableField[] = [
      {
        name: 'area',
        label: '管轄',
        type: 'convFunc',
        convFunc: (area: string) => getAreaNameForDisp(area),
      },
      { name: 'alias_name', label: '本社/局/協力会社' },
      { name: 'formal_name', label: '正式名称' },
      { name: 'ability_names', label: '作業種別' },
    ];

    const doSearch = async(): Promise<void> => {
      const { data: companies } = await johaisetsuCompanyMasterAbilityApi.adminIndex();
      state.companies = companies.map(e => {
        return {
          ...e,
          ability_names: getAbilityNamesForDisp(e.abilities),
          formal_name: e.is_partner_company ? e.name : '',
        };
      });
    };

    const loadAvailableAbilities = async(): Promise<void> => {
      const { data: abilities } = await abilityApi.adminIndex();
      state.availableAbilities = filterJohaisetsuDriverAbilities(abilities);
    };

    onMounted(async() => {
      try {
        await Promise.all([doSearch(), loadAvailableAbilities()]);
      } catch (err) {
        state.errorBody = '一覧の取得に失敗しました。再度操作を行ってください';
      }
    });

    const edit = (obj: AdminJohaisetsuCompanyMasterAbility): void => {
      state.editting = {
        id: obj.id,
        alias_name: obj.alias_name,
        ability_ids: obj.abilities.map(e => e.id),
      };
      state.showEditModal = true;
    };

    const save = async(): Promise<void> => {
      try {
        await johaisetsuCompanyMasterAbilityApi.adminUpdate(state.editting.id, {
          ability_ids: state.editting.ability_ids,
        });
        state.showEditModal = false;
        await doSearch();
      } catch (err) {
        state.errorBody = '保存に失敗しました。再度操作を行ってください';
      }
    };

    const editModalTitle = '編集';

    return {
      state,
      fields,
      canDeleteRow,
      canEditRow,
      edit,
      save,
      editModalTitle,
    };
  },
});
